import { createSlice } from '@reduxjs/toolkit';
import { getHoldReasonList } from '../apis/holdAPIs';

interface initialStateInterFace {
	error: any;
	loading: boolean;
	currentPage: number;
	count: number;
	searchKey: string;
	page: number;
	holdList: Array<any>;
}

const initialState: initialStateInterFace = {
	error: '',
	loading: false,
	currentPage: 0,
	count: 0,
	searchKey: '',
	page: 0,
	holdList: []
};
const holdSlice = createSlice({
	name: 'holdSlice',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(getHoldReasonList.pending, (state: initialStateInterFace) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			getHoldReasonList.fulfilled,
			(state: initialStateInterFace, action: any) => {
				state.loading = false;
				state.error = '';
                state.holdList = action?.payload?.data || []
			}
		);
		builder.addCase(getHoldReasonList.rejected, (state: initialStateInterFace) => {
			state.loading = false;
		});
	}
});
export default holdSlice.reducer;
